export const SlotItemTypeList = ['bar', 'dot', 'circle', 'triangle', 'cross'];
